import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyVideoStepsBanner from "./component";
import { setHammerSwipe } from "../post-inspection-diy/actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setHammerSwipeConnect: setHammerSwipe
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyVideoStepsBanner);
